import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';

import 'Lib/jquery.scrolltofixed';

"use strict";

var ViewCollectionNav = Backbone.View.extend({

    initialize: function (opts) {
        var self = this;
        self.$nav = self.$el;
        self.$sorter = self.$nav.find('.collection-nav-block.sorting');
        self.$filter = self.$nav.find('.collection-nav-block.filters');
        self.$body = $('body');
        self.$header = $('header.site-header');
        self.$footer = $('footer.site-footer');
        
        self.prepareParams();
        if(!self.$body.hasClass('ss-enabled')){
            self.navDropdown();
            self.initSorting();
            self.initFiltering();
        }
        // self.navFix();
        
    },

    events: {
        
    },
    
    prepareParams: function(){
        var self = this;
        if (location.search.length) {
            for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
                aKeyValue = aCouples[i].split('=');
                // console.log(aKeyValue);
                if (aKeyValue.length > 1) {
                    Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
                }
            }
        }
        
        // Clean the pagination
        delete Shopify.queryParams.page;
        delete Shopify.queryParams.showAll;
        
        if (!$.isEmptyObject(Shopify.queryParams)) {
            // $('.collection-nav-block.clear-all').removeClass('hide');
            // $('.clear-all.clear-all-sort').removeClass('hide');
        }
    },

    navDropdown: function(){
        var self = this;
        var events = {
            'click .collection-nav' : function(e){
                e.stopPropagation();
            },
            'click .nav-title:not(.clear-all-ctl)' : function(e){
                e.preventDefault();
                e.stopPropagation();
                var $curr = $(e.currentTarget);
                if ($curr.parent().hasClass('opened')) {
                    $curr.parent().removeClass('opened');
                    if(!$(e.currentTarget).parent().hasClass('sorting')){
                        self.$body.removeClass('collection-nav-opened');
                    }
                } else {
                    if(!$(e.currentTarget).parent().hasClass('sorting')){
                        self.$body.addClass('collection-nav-opened');
                    }else{
                        self.$nav.find('.filter').removeClass('opened')
                    }
                    $curr.parent().siblings('.collection-nav-block').removeClass('opened');
                    $curr.parent().addClass('opened');
                }
            },
            'click .filter-title' : function(e){
                if(!ORW.utilities.isMobile()){
                    e.preventDefault();
                    e.stopPropagation();
                    var $curr = $(e.currentTarget);
                    if ($curr.parent().hasClass('opened')) {
                        $curr.parent().removeClass('opened');
                        self.$body.removeClass('collection-nav-opened');
                    } else {
                        self.$body.addClass('collection-nav-opened');
                        $curr.parent().siblings('.filter').removeClass('opened');
                        self.$body.find('.sorting').removeClass('opened');
                        $curr.parent().addClass('opened');
                    }
                }
            },
            'click .mobile-nav-close' : function(e){
                var $curr = $(e.currentTarget);
                self.$body.removeClass('collection-nav-opened');
                $curr.siblings('.collection-nav-block').removeClass('opened');
            }
        };
        
        // Click outside to close
        $(window).on('click', function (e) {
            self.$body.removeClass('collection-nav-opened');
            self.$nav.find('.filter').removeClass('opened')
            self.$nav.find('.collection-nav-block').removeClass('opened');
        });
        
        // Update and delegate adding events
        _.extend(self.events, events);
        self.delegateEvents();
    },
    
    navFix: function(){
        var self = this,
            lastScrollTop = 0;

        self.$nav.scrollToFixed({
            removeOffsets: true,
            spacerClass: 'fixed',
            zIndex: 999,
            dontSetWidth: true,
            marginTop: self.$header.outerHeight(true) + 10,
            limit: function() {
                var limit = self.$footer.offset().top - self.$nav.outerHeight(true);
                return limit;
            }
        });
    },
    
    initSorting: function(){
        var self = this;

        var events = {
            'click .collection-nav-block.sorting .filter' : function(e){
                e.preventDefault();
                var $curr = $(e.currentTarget),
                    sortVal = $curr.data('link');
                
                if (sortVal != '') {
                    $curr.addClass('active').siblings('.filter').removeClass('active');
                    Shopify.queryParams.sort_by = $curr.data('link');
                } else {
                    delete Shopify.queryParams.sort_by;
                }

                location.search = $.param(Shopify.queryParams);
            }
        }

        //Hide filter header when all options are disabled
        _.each(self.$filter.find('.filter'), function(filterGroup){
            var $filterGroup = $(filterGroup);
            var $swatchCount = $filterGroup.find('.filter-swatch').not('.disabled');
            if($swatchCount.length < 1){
                $filterGroup.hide();
            }
        });
        
        // Active Status
        if (Shopify.queryParams.sort_by) {
            self.$sorter.find('*[data-link="' + Shopify.queryParams.sort_by + '"]').addClass('active');
        }else{
            console.log('assign first filter as default');
            self.$sorter.find('.filter').first().addClass('active');
        }
        
        // Update and delegate adding events
        _.extend(self.events, events);
        self.delegateEvents();
    },
    
    initFiltering: function(){
        var self = this;
        var $filterSelects = self.$filter.find('select');
        var events = {
            'click .clear-all-filters' : function(e){
                e.preventDefault();
                var newURL = '/collections/' + Shopify.collectionHandle;
                var search = $.param(Shopify.queryParams);
                if (search.length) {
                    newURL += '?' + search;
                }
                location.href = newURL;
            },
            'click .collection-nav-block.filters a' : function(e){
                e.preventDefault();
                var $curr = $(e.currentTarget),
                    $filterParent = $curr.parents('.filter-swatches'),
                    $fitlerSelect = $filterParent.siblings('select'),
                    filterVal = $curr.attr('href');
                    
                if ($curr.hasClass('disabled')) {
                    return false;
                }
                
                if (filterVal !== '') {
                    $curr.addClass('active').siblings('a').removeClass('active');
                    $fitlerSelect.val(filterVal).change();
                } else {
                    var newURL = '/collections/' + Shopify.collectionHandle;
                    var search = $.param(Shopify.queryParams);
                    if (search.length) {
                        newURL += '?' + search;
                    }
                    location.href = newURL;
                }
                
            },
            'change .collection-nav-block.filters select' : function(e){
                delete Shopify.queryParams.page;
                var newTags = [];
                _.each($filterSelects, function(select){
                    if ($(select).val()) {
                        newTags.push($(select).val());
                    }
                });
                if (Shopify.collectionHandle) {
                    // PLP
                    var newURL = '/collections/' + Shopify.collectionHandle;
                    var search = $.param(Shopify.queryParams);
                    
                    if (newTags.length) {
                        newURL += '/' + newTags.join('+');
                    }
                    if (search.length) {
                        newURL += '?' + search;
                    }
                    
                    location.href = newURL;
                } else {
                    // Search
                    if (newTags.length) {
                        Shopify.queryParams.constraint = newTags.join('+');
                    } else {
                        delete Shopify.queryParams.constraint;
                    }

                    location.search = $.param(Shopify.queryParams);
                }
            }
        }
        
        // Update and delegate adding events
        _.extend(self.events, events);
        self.delegateEvents();
    },
    
    destroy: function() {
        var self = this;
        self.undelegateEvents();
    }

});

export default ViewCollectionNav;